import { render, staticRenderFns } from "./needsModel.vue?vue&type=template&id=11e603da&scoped=true&"
import script from "./needsModel.vue?vue&type=script&lang=js&"
export * from "./needsModel.vue?vue&type=script&lang=js&"
import style0 from "./needsModel.vue?vue&type=style&index=0&id=11e603da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e603da",
  null
  
)

export default component.exports